import { generatePopulation, type DistributionSpec } from '../../statistics';

export interface PopulationPreset {
  id: string;
  labelKey: string;
  spec: DistributionSpec;
  seed: number;
  /** Optional pre-baked stratum tags (one per population element). */
  strata?: readonly string[];
}

const N = 10_000;

function buildBimodalStrata(seed: number): { values: number[]; strata: string[] } {
  const values = generatePopulation(
    { id: 'bimodal', params: { mu1: 35, mu2: 75, sigma: 6, mix: 0.5 } },
    N,
    seed,
  );
  const strata = values.map((v) => (v < 55 ? 'low' : 'high'));
  return { values, strata };
}

const BIMODAL = buildBimodalStrata(11);

export const POPULATIONS: Record<string, PopulationPreset & { values: number[] }> = {
  gaussian: {
    id: 'gaussian',
    labelKey: 'population.gaussian.label',
    spec: { id: 'gaussian', params: { mu: 70, sigma: 10 } },
    seed: 1,
    values: generatePopulation({ id: 'gaussian', params: { mu: 70, sigma: 10 } }, N, 1),
  },
  'right-skewed': {
    id: 'right-skewed',
    labelKey: 'population.right-skewed.label',
    spec: { id: 'skewed-right', params: { mode: 30, sigma: 0.6 } },
    seed: 2,
    values: generatePopulation({ id: 'skewed-right', params: { mode: 30, sigma: 0.6 } }, N, 2),
  },
  bimodal: {
    id: 'bimodal',
    labelKey: 'population.bimodal.label',
    spec: { id: 'bimodal', params: { mu1: 35, mu2: 75, sigma: 6, mix: 0.5 } },
    seed: 11,
    values: BIMODAL.values,
    strata: BIMODAL.strata,
  },
  uniform: {
    id: 'uniform',
    labelKey: 'population.uniform.label',
    spec: { id: 'uniform', params: { min: 0, max: 100 } },
    seed: 3,
    values: generatePopulation({ id: 'uniform', params: { min: 0, max: 100 } }, N, 3),
  },
};
